import { render, staticRenderFns } from "./fileCheck.vue?vue&type=template&id=6d748221&scoped=true&"
import script from "./fileCheck.vue?vue&type=script&lang=js&"
export * from "./fileCheck.vue?vue&type=script&lang=js&"
import style0 from "./fileCheck.vue?vue&type=style&index=0&id=6d748221&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d748221",
  null
  
)

export default component.exports